import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { HelperService } from 'gp-admin-abstract';
import { ImageUploadModel } from './image-upload.model';
var ImageUploadComponent = /** @class */ (function () {
    function ImageUploadComponent(sanitizer, helperService) {
        this.sanitizer = sanitizer;
        this.helperService = helperService;
        /**
         * Список отображемых изображений на форме
         *
         * @type {Array}
         */
        this.internalImages = [];
        /**
         * Список удаленных картинок (полученных с сервера)
         *
         * @type {Array}
         */
        this.deletedImages = [];
        /**
         * Заголовок
         * @type {string}
         */
        this.title = '';
        /**
         * Описание
         * @type {string}
         */
        this.description = '';
        /**
         * Список разрешенных MIME-типов
         */
        this.mimeTypes = ['image/png', 'image/jpeg', 'image/jpg'];
        /**
         * Кастомная ошибка
         * @type {boolean}
         */
        this.error = false;
        /**
         * Устанавливает активность компонента
         * <TODO нужны стили &--disabled>
         * @type {boolean}
         */
        this.disabled = false;
        this.propagateChange = function (_) {
        };
    }
    ImageUploadComponent.prototype.ngOnInit = function () {
        this.returnValue = new ImageUploadModel();
        this.internalImages.push({
            isLoaded: false,
            error: null,
            imageGuid: '',
            selectedFile: null,
            selectedFileSrc: null
        });
    };
    ImageUploadComponent.prototype.writeValue = function (value) {
        if (value && value.existsGuids) {
            for (var _i = 0, _a = value.existsGuids; _i < _a.length; _i++) {
                var imageGuid = _a[_i];
                this.internalImages.push({
                    isLoaded: true,
                    error: this.error,
                    imageGuid: imageGuid,
                    selectedFile: null,
                    selectedFileSrc: null
                });
            }
            this.checkForInsert();
            this.returnValue.existsGuids = value.existsGuids;
        }
    };
    ImageUploadComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    ImageUploadComponent.prototype.registerOnTouched = function (fn) {
    };
    ImageUploadComponent.prototype.setDisabledState = function (value) {
        this.disabled = value;
    };
    /**
     * Выбрали и загружаем картинку
     *
     * @param e
     * @param index
     */
    ImageUploadComponent.prototype.onChange = function (e, index) {
        if (!this.disabled) {
            var el = e.srcElement || e.target;
            var file = el.files.length > 0 ? el.files[0] : null;
            if (file) {
                this.updateModel(file, index);
            }
        }
    };
    /**
     * Запрещаем изменение картинки
     * И если disabled - делаем кнопку неактивной
     *
     * @param e
     * @param index
     */
    ImageUploadComponent.prototype.onClick = function (e, index) {
        if (this.disabled || this.internalImages[index] && this.internalImages[index].isLoaded) {
            e.preventDefault();
        }
    };
    /**
     * Проверка картинки на загрузку
     *
     * @param file
     * @param index
     */
    ImageUploadComponent.prototype.updateModel = function (file, index) {
        if (this.mimeTypes.indexOf(file.type) === -1) {
            this.internalImages[index].error = 'Неверный тип файла!';
            this.internalImages[index].isLoaded = false;
        }
        else if (!!this.maxSize && (file.size > this.maxSize)) {
            var pretty = this.helperService.filesize(this.maxSize);
            this.internalImages[index].error = "\u0420\u0430\u0437\u043C\u0435\u0440 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0435\u0442 " + pretty;
            this.internalImages[index].isLoaded = false;
        }
        else {
            this.internalImages[index] = {
                isLoaded: true,
                error: false,
                selectedFile: file,
                selectedFileSrc: URL.createObjectURL(file)
            };
            this.propagateChange(this.returnValues());
            this.checkForInsert();
        }
    };
    /**
     * Удалить загруженную картинку
     *
     * @param e
     * @param index
     */
    ImageUploadComponent.prototype.deleteLoadedImage = function (e, index) {
        e.preventDefault();
        if (this.internalImages[index].imageGuid) {
            this.deletedImages.push(this.internalImages[index].imageGuid);
        }
        this.internalImages.splice(index, 1);
        this.propagateChange(this.returnValues());
        this.checkForInsert();
    };
    ImageUploadComponent.prototype.reset = function () {
        this.internalImages = [];
        this.deletedImages = [];
        this.returnValue = new ImageUploadModel();
        this.internalImages.push({
            isLoaded: false,
            error: null,
            imageGuid: '',
            selectedFile: null,
            selectedFileSrc: null
        });
    };
    /**
     * Получить загруженную картинку и установить ее отображение
     *
     * @returns {SafeStyle}
     */
    ImageUploadComponent.prototype.imageSrc = function (index) {
        var src = (this.internalImages[index] && this.internalImages[index].selectedFile)
            ? this.internalImages[index].selectedFileSrc : this.imageUrlPrefix + this.internalImages[index].imageGuid;
        return this.sanitizer.bypassSecurityTrustStyle('url(' + src + ')');
    };
    Object.defineProperty(ImageUploadComponent.prototype, "acceptMimeTypes", {
        /**
         * Получить разрешенные типы картинки
         *
         * @returns {any}
         */
        get: function () {
            return (this.mimeTypes instanceof Array) ? this.mimeTypes.join(',') : this.mimeTypes;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Проверка на отображение кнопки "добавления фото"
     */
    ImageUploadComponent.prototype.checkForInsert = function () {
        var alreadyShowInsert = this.internalImages.find(function (f) { return f.isLoaded === false; }), currentLength = alreadyShowInsert ? this.internalImages.length - 1 : this.internalImages.length;
        if (!alreadyShowInsert && (currentLength < this.maxCountFiles)) {
            this.internalImages.push({
                isLoaded: false,
                error: this.error,
                imageGuid: null,
                selectedFile: null,
                selectedFileSrc: null
            });
        }
        else if (alreadyShowInsert && (currentLength === this.maxCountFiles)) {
            var index = this.internalImages.indexOf(alreadyShowInsert);
            this.internalImages.splice(index, 1);
        }
    };
    /**
     * Возвращаемое значение
     *
     * @returns {Object}
     */
    ImageUploadComponent.prototype.returnValues = function () {
        var uploadedImages = this.internalImages
            .filter(function (f) { return f.isLoaded === true && f.selectedFile; })
            .map(function (f) { return f.selectedFile; });
        this.returnValue.addedFiles = uploadedImages;
        this.returnValue.deletedGuids = this.deletedImages;
        return this.returnValue;
    };
    ImageUploadComponent.decorators = [
        { type: Component, args: [{
                    selector: 'gp-image-upload',
                    template: "\n<div class=\"flex\">\n\n  <div\n    class=\"img-uploader flex flex--content-center flex--align-center\"\n    *ngFor=\"let model of internalImages; let i = index;\"\n    [ngClass]=\"{\n      'img-uploader--loaded': model.isLoaded,\n      'img-uploader--error': !!model.error,\n      'img-uploader--disabled': disabled\n      }\">\n\n    <label class=\"img-uploader__label flex flex--align-center\">\n\n      <input\n        type=\"file\"\n        name=\"upload_{{i}}\"\n        class=\"img-uploader__input\"\n        id=\"upload_{{i}}\"\n        (click)=\"onClick($event, i)\"\n        (change)=\"onChange($event, i)\"\n        accept=\"{{acceptMimeTypes}}\"\n      >\n\n      <div class=\"img-uploader__wrapper flex flex--content-center flex--align-center pr border-radius--all\">\n\n        <div class=\"img-uploader__default\" *ngIf=\"!model.isLoaded\"></div>\n\n        <div class=\"img-uploader__img\" *ngIf=\"model.isLoaded\" [style.background-image]=\"imageSrc(i)\">\n          <div class=\"img-uploader__delete\" (click)=\"deleteLoadedImage($event, i)\"></div>\n        </div>\n\n      </div>\n\n    </label>\n\n  </div>\n\n  <!--<div class=\"img-uploader__info flex flex&#45;&#45;align-center\">-->\n    <!--<div class=\"img-uploader__title\" *ngIf=\"title !== ''\">{{title}}</div>-->\n    <!--<div class=\"img-uploader__description\" *ngIf=\"description !== ''\">{{description}}</div>-->\n  <!--</div>-->\n\n</div>\n",
                    styles: [
                        "@charset \"UTF-8\";\n/**\n * \u041F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0435\n */\n:root {\n  --color-white: white;\n  --color-success: #00afec;\n  --color-warning: #ffb827;\n  --color-error: #f35252;\n  --color-disabled: #dbdbdb;\n  --color-black: black;\n  --color-span: #b5b5b5;\n  --color-span-second: #212121;\n  --color-bg: #f8f8f8;\n  --color-bg-second: #f8f8f8;\n  --color-bg-success: rgba(0, 175, 236, 0.1);\n  --color-bg-warning: var(--color-warning);\n  --color-bg-error: var(--color-error);\n  --color-placeholder: #b5b5b5;\n  --color-border: #dbdbdb;\n  --color-radio-border: #d3d3d3;\n  --font-roboto: 'Roboto', sans-serif;\n  --font-helvetica: 'Helvetica', sans-serif; }\n\n/**\n *\n */\n/**\n *  \u0421\u0442\u0438\u043B\u0438 \u0434\u043B\u044F \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0430 \"app-realty-image-list\"\n */\n.img-uploader {\n  font-family: \"Roboto\", sans-serif;\n  margin-top: .8rem;\n  margin-bottom: .8rem; }\n  .img-uploader--loaded .img-uploader__label:hover {\n    cursor: default;\n    opacity: 1; }\n  .img-uploader--error .img-uploader__default {\n    background-image: url(\"/assets/img/camera--error.svg\");\n    border-color: #f35252; }\n  .img-uploader--disabled .img-uploader__default {\n    background-image: url(\"/assets/img/camera--disabled.svg\");\n    border-color: #b5b5b5; }\n  .img-uploader__label {\n    display: block;\n    cursor: pointer; }\n    .img-uploader__label:hover {\n      opacity: 0.5; }\n  .img-uploader__input {\n    display: none; }\n  .img-uploader__title, .img-uploader__description {\n    font: 500 1.4rem/1.6rem \"Roboto\", sans-serif;\n    letter-spacing: .03rem;\n    margin-bottom: .3rem;\n    width: 100%; }\n  .img-uploader__title {\n    color: #00afec; }\n  .img-uploader__description {\n    color: #b5b5b5; }\n  .img-uploader__info {\n    align-content: center;\n    margin-left: 1.6rem; }\n  .img-uploader__default {\n    background-image: url(\"/assets/img/camera.svg\");\n    background-position: center center;\n    background-repeat: no-repeat;\n    border: 0.2rem dotted #00afec;\n    border-radius: .3rem;\n    width: 6rem;\n    height: 6rem; }\n  .img-uploader__img {\n    background-color: #ccc;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    border-radius: .3rem;\n    width: 6rem;\n    height: 6rem;\n    position: relative;\n    margin-right: 1.6rem; }\n  .img-uploader__delete {\n    background-color: rgba(255, 255, 255, 0.8);\n    width: 2.5rem;\n    height: 2.5rem;\n    position: absolute;\n    top: 0;\n    right: 0;\n    border-radius: 0 0 0 3rem;\n    cursor: pointer; }\n    .img-uploader__delete:before, .img-uploader__delete:after {\n      content: \"\";\n      display: block;\n      width: .2rem;\n      height: 1rem;\n      background-color: #f35252;\n      position: absolute; }\n    .img-uploader__delete:before {\n      -moz-transform: translate(1.5rem, 0.5rem) rotate(45deg);\n      -o-transform: translate(1.5rem, 0.5rem) rotate(45deg);\n      -ms-transform: translate(1.5rem, 0.5rem) rotate(45deg);\n      -webkit-transform: translate(1.5rem, 0.5rem) rotate(45deg);\n      transform: translate(1.5rem, 0.5rem) rotate(45deg); }\n    .img-uploader__delete:after {\n      -moz-transform: translate(15px, 5px) rotate(-45deg);\n      -o-transform: translate(15px, 5px) rotate(-45deg);\n      -ms-transform: translate(15px, 5px) rotate(-45deg);\n      -webkit-transform: translate(15px, 5px) rotate(-45deg);\n      transform: translate(15px, 5px) rotate(-45deg); }\n    .img-uploader__delete:hover {\n      background-color: white; }\n"
                    ],
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: ImageUploadComponent,
                            multi: true
                        }
                    ],
                },] },
    ];
    /** @nocollapse */
    ImageUploadComponent.ctorParameters = function () { return [
        { type: DomSanitizer, },
        { type: HelperService, },
    ]; };
    ImageUploadComponent.propDecorators = {
        'title': [{ type: Input },],
        'description': [{ type: Input },],
        'maxCountFiles': [{ type: Input },],
        'mimeTypes': [{ type: Input },],
        'maxSize': [{ type: Input },],
        'error': [{ type: Input },],
        'disabled': [{ type: Input },],
        'imageUrlPrefix': [{ type: Input },],
    };
    return ImageUploadComponent;
}());
export { ImageUploadComponent };
//# sourceMappingURL=image-upload.component.js.map